/**
 * Config API Module
 *
 * This module provides functions to interact with the configuration API endpoints.
 * It allows retrieving and updating configuration settings for the application.
 */

import { ConfigItem } from "../types";
import getAPIEndpoint from "./APIEndpoint";

// Get authentication token from local storage
const token = localStorage.getItem("token");

/**
 * Fetches configuration data from the server
 *
 * @returns {Promise<ConfigItem[]>} A promise that resolves to an array of configuration items
 * @throws Will return an empty array if the request fails
 */
export const getConfig = async (): Promise<ConfigItem[]> => {
  const result = await fetch(`${getAPIEndpoint()}/config`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });

  if (result.ok) {
    const data = await result.json();
    if (data.success && data.data) {
      return data.data as ConfigItem[];
    }
  }

  return [];
};

/**
 * Updates a configuration item on the server
 *
 * @param {ConfigItem} config - The configuration item to update
 * @param {number} accountId - The account ID associated with this configuration
 * @returns {Promise<any>} A promise that resolves to the server response
 * @throws Will log an error to the console if the request fails
 */
export const updateConfig = async (config: ConfigItem, accountId: number) => {
  return fetch(`${getAPIEndpoint()}/config`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token || "",
      AccountId: accountId as any,
    },
    body: JSON.stringify(config),
  })
    .then((response) => response.json())
    .catch((error) => console.error("Error updating config:", error));
};
